<template>
  <div class="feedback-wrapper">
    <el-table :data="datalist" style="width: 100%">
      <el-table-column label="id" prop="dataId" width="60"></el-table-column>
      <el-table-column label="内容" width="700">
        <template slot-scope="scope">
          <p>标题：{{ scope.row.title }}</p>
          <p>问题：{{ scope.row.content }}</p>

          <p>创建时间：{{ scope.row.createTime }}</p>
          <div v-if="scope.row.responseContent" class="reply">
            <span style="minWidth: 38px">回复：</span
            ><span>{{ scope.row.responseContent }}</span>
          </div>
          <p>回复时间：{{ scope.row.responseTime }}</p>
          <span style="margin-left: 10px">{{ scope.row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        prop="stateText"
        width="140"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.row)"
            v-if="!scope.row.state"
            type="primary"
            >回复</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-drag:common
      :visible="visible"
      title="回复"
      width="600px"
      @close="visible = false"
    >
      <el-form>
        <el-form-item label="回复内容">
          <el-input
            type="textarea"
            :rows="4"
            v-model="responseContent"
            require
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="submit">提交</el-button>
        <el-button @click="visible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [],
      visible: false,
      responseContent: '',
      dataId: null
    };
  },
  computed: {
    datalist() {
      const list = this.data.map(item => {
        if (item.state === 0) {
          item.stateText = '未回复';
        } else {
          item.stateText = '已回复';
        }
        return item;
      });
      return list;
    }
  },
  async mounted() {
    await this.getSuggestionByUser();
  },
  methods: {
    async getSuggestionByUser() {
      const { data } = await this.$fetch('/manage/getSuggestionByUser', {
        module: 'manage'
      });
      this.data = data.contentList;
    },
    async handleEdit(row) {
      this.visible = true;
      this.dataId = row.dataId;
    },
    async submit() {
      if (!this.responseContent)
        return this.$message({
          type: 'waring',
          message: '请填写回复内容'
        });
      await this.$postForm('/manage/updateSuggestionByUser', {
        data: {
          dataId: this.dataId,
          responseContent: this.responseContent
        },
        module: 'manage',
        showLoading: true,
        showError: true,
        showSuccess: true
      });
      await this.getSuggestionByUser();
      this.responseContent = '';
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.feedback-wrapper {
  padding: 16px;

  .reply {
    padding: 0px;
    line-height: 14px;
    width: 100%;
    min-height: 40px;
    white-space: pre-line;
    display: flex;
  }
  p {
    padding: 0px;
    line-height: 14px;
  }
  /deep/.el-form {
    .el-form-item__label {
      color: #ffffff;
    }
  }
  /deep/.el-table__empty-block {
    background-color: #fff;
  }

  /deep/.el-textarea__inner {
    background-color: transparent;
    color: #fff;
  }
}
</style>
